import React, { useEffect } from 'react'
import { HiXMark } from 'react-icons/hi2'
import { cn } from './cn'

export function Modal({ open, onClose, title, description, children, size = 'md', className }) {
  useEffect(() => {
    if (!open) return
    const onKey = (e) => {
      if (e.key === 'Escape') onClose?.()
    }
    document.addEventListener('keydown', onKey)
    document.body.style.overflow = 'hidden'
    return () => {
      document.removeEventListener('keydown', onKey)
      document.body.style.overflow = ''
    }
  }, [open, onClose])

  if (!open) return null

  const sizeClass = {
    sm: 'max-w-md',
    md: 'max-w-lg',
    lg: 'max-w-2xl',
    xl: 'max-w-4xl',
    full: 'max-w-6xl',
  }[size]

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <button
        type="button"
        className="absolute inset-0 bg-secondary-900/50 backdrop-blur-sm dark:bg-black/60"
        aria-label="Close dialog"
        onClick={onClose}
      />
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby={title ? 'modal-title' : undefined}
        className={cn(
          'relative z-10 w-full animate-slide-up rounded-xl border border-muted bg-card shadow-xl dark:border-muted-dark dark:bg-card-dark',
          sizeClass,
          className
        )}
      >
        {(title || onClose) && (
          <div className="flex items-start justify-between gap-4 border-b border-muted px-6 py-4 dark:border-muted-dark">
            <div>
              {title && (
                <h2 id="modal-title" className="text-lg font-semibold text-secondary-900 dark:text-secondary-50">
                  {title}
                </h2>
              )}
              {description && <p className="mt-1 text-sm text-text-muted dark:text-text-muted-dark">{description}</p>}
            </div>
            {onClose && (
              <button
                type="button"
                onClick={onClose}
                className="rounded-lg p-1 text-secondary-500 hover:bg-secondary-100 dark:hover:bg-secondary-800"
                aria-label="Close"
              >
                <HiXMark className="h-5 w-5" />
              </button>
            )}
          </div>
        )}
        <div className="px-6 py-4">{children}</div>
      </div>
    </div>
  )
}
